import { render, staticRenderFns } from "./destinations.vue?vue&type=template&id=166ab4cc&scoped=true"
import script from "./destinations.vue?vue&type=script&lang=js"
export * from "./destinations.vue?vue&type=script&lang=js"
import style0 from "./destinations.vue?vue&type=style&index=0&id=166ab4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ab4cc",
  null
  
)

export default component.exports